import React from 'react';
import { Button } from './Button';
import { FadeIn } from './FadeIn';
import { BookOpen, TrendingUp, ShieldCheck, Download, Zap } from 'lucide-react';
export function Hero() {
  const goToCheckout = () => {
    window.open('https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos', '_blank');
  };
  return <section className="bg-brand-white pt-24 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-169">
      <div className="max-w-6xl mx-auto" data-id="element-170">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-171">
          <div className="flex-1 text-center lg:text-left" data-id="element-172">
            <FadeIn data-id="element-173">
              <div className="inline-block bg-brand-green text-white font-bold px-8 py-3.5 rounded-full text-lg md:text-xl mb-6 border border-brand-gold/40 tracking-widest uppercase shadow-xl" data-id="element-174">
                INGRESOS ONLINE DESDE CASA
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-175">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-green leading-tight mb-6" data-id="element-176">
                APRENDE A GENERAR INGRESOS DESDE CASA USANDO AMAZON, INCLUSO SI
                EMPIEZAS DESDE CERO
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-177">
              <p className="text-sm font-semibold text-brand-gold uppercase tracking-wider mb-4" data-id="element-178">
                Paso a paso | Sin experiencia | Acceso inmediato | Amazon Seller
              </p>
              <p className="text-lg md:text-xl text-brand-text mb-4 leading-relaxed" data-id="element-179">
                Aprende paso a paso cómo utilizar la plataforma de ventas Amazon
                Seller desde cero: cómo publicar productos, crear campañas,
                gestionar pedidos y comenzar correctamente aunque no tengas
                experiencia previa.
              </p>
              <p className="text-lg md:text-xl text-brand-text mb-8 leading-relaxed" data-id="element-180">
                Descubre cómo funciona realmente Amazon para vender con más
                estructura, menos errores y mayor claridad desde casa. Además,
                con los bonos incluidos conocerás productos con potencial y cómo
                identificarlos estratégicamente.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-181">
              <div className="bg-brand-beige/50 p-6 rounded-xl mb-10 border border-brand-gold/20" data-id="element-182">
                <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-brand-text font-medium" data-id="element-183">
                  <span data-id="element-184">✔️ Acceso inmediato</span>
                  <span data-id="element-185">✔️ Método claro y fácil de seguir</span>
                  <span data-id="element-186">✔️ Ideal para principiantes</span>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-187">
              <Button onClick={goToCheckout} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-188">
                QUIERO EMPEZAR A GENERAR INGRESOS DESDE CASA
              </Button>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-189">
                <span className="flex items-center gap-1.5" data-id="element-190">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-191" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-192">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-193" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-194">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-195" />
                  COMPRA SEGURA
                </span>
              </div>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none" data-id="element-196">
            <FadeIn delay={0.3} data-id="element-197">
              <img src="https://cdn.magicpatterns.com/uploads/91JGFMLPCxeBmQ6GN9u4tX/portada_como_vender_en_amazon_comprimida_.png" alt="Cómo Vender en Amazon FBA Desde Cero (2026) - Guía Completa" className="w-full h-auto rounded-2xl shadow-2xl object-contain" data-id="element-198" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}